import { createContext } from 'react';
import { HomeContextType } from '#home/contexts';

const HomeContext = createContext<HomeContextType>(null);

export { HomeContext };
